import axios from "axios";
import { base_url, headers } from "../constants";

// ---------- CREATE PORTFOLIO
export const createPortfolio = async (body) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.post(
            `${base_url}/api/v1/portfolios`,
            body,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200 || response.status === 201
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Create portfolio error:", error);
        return { success: false, error };
    }
};

// ---------- GET ALL PORTFOLIOS
export const getAllPortfolios = async () => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    const market = sessionStorage.getItem("selectedMarket") ?? "US";

    try {
        const response = await axios.get(
            `${base_url}/api/v1/portfolios`,
            {
                params: { market: market },
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Get portfolios error:", error);
        return { success: false, error };
    }
};

// ---------- GET PORTFOLIO BY ID
export const getPortfolioById = async (portfolioId) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.get(
            `${base_url}/api/v1/portfolios/${portfolioId}`,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Get portfolio by ID error:", error);
        return { success: false, error };
    }
};

// ---------- UPDATE PORTFOLIO
export const updatePortfolio = async (portfolioId, body) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.patch(
            `${base_url}/api/v1/portfolios/${portfolioId}`,
            body,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Update portfolio error:", error);
        return { success: false, error };
    }
};

// ---------- DELETE PORTFOLIO
export const deletePortfolio = async (portfolioId) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.delete(
            `${base_url}/api/v1/portfolios/${portfolioId}`,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200 || response.status === 204
            ? { success: true }
            : { success: false };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Delete portfolio error:", error);
        return { success: false, error };
    }
};

// ---------- ADD HOLDING TO PORTFOLIO
export const addHoldingToPortfolio = async (portfolioId, body) => {
    const token = sessionStorage.getItem("authToken");

    try {
        const res = await axios.post(
            `${base_url}/api/v1/portfolios/${portfolioId}/holdings`,
            body,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return { success: res.status === 200, data: res.data };
    } catch (e) {
        return { success: false, error: e };
    }
};

// ---------- UPDATE HOLDING
export const updateHolding = async (portfolioId, ticker, body) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.patch(
            `${base_url}/api/v1/portfolios/${portfolioId}/holdings/${ticker}`,
            body,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Update holding error:", error);
        return { success: false, error };
    }
};

// ---------- REMOVE HOLDING
export const removeHoldingFromPortfolio = async (portfolioId, ticker) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.delete(
            `${base_url}/api/v1/portfolios/${portfolioId}/holdings/${ticker}`,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200 || response.status === 204
            ? { success: true }
            : { success: false };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Remove holding error:", error);
        return { success: false, error };
    }
};

// ---------- GET PORTFOLIO HEALTH SCORE
export const getPortfolioHealthScore = async (portfolioName) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.get(
            `${base_url}/api/v1/portfolios/portfolio-health-score/${portfolioName}`,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Get portfolio by ID error:", error);
        return { success: false, error };
    }
};

// ---------- FRONTIER ANALYSIS
export const frontierAnalysis = async (body) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await axios.post(
            `${base_url}/api/v1/efficient_frontier/api/v1/portfolio/efficient-frontier`,
            body,
            {
                headers: {
                    ...headers,
                    Authorization: `Bearer ${jwtToken}`,
                },
                withCredentials: false,
            }
        );

        return response.status === 200 || response.status === 201
            ? { success: true, data: response.data }
            : { success: false, data: response.data };
    } catch (error) {
        if (error?.response?.status === 401) {
            return { success: false, authExpired: true };
        }
        console.error("Create portfolio error:", error);
        return { success: false, error };
    }
};

// ---------- EQUAL WEIGHTS
export const getEqualWeights = async (selectedPortfolioId) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };

    try {
        const response = await fetch(
            `${base_url}/api/v1/portfolios/${selectedPortfolioId}/rebalance`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            }
        );

        if (!response.ok) {
            throw new Error("Failed to calculate rebalance");
        }

        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: error.message };
    }
};

// ---------- APPLY EQUAL WEIGHTS
export const applyEqualWeights = async (portfolioId) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };
    try {
        const response = await fetch(
            `${base_url}/api/v1/portfolios/${portfolioId}/rebalance/apply`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
                credentials: "include", // Include cookies for authentication
            }
        );

        // Handle authentication errors
        if (response.status === 401 || response.status === 403) {
            return { success: false, authExpired: true };
        }

        const data = await response.json();

        if (!response.ok) {
            return {
                success: false,
                message: data.message || "Failed to apply rebalancing",
            };
        }

        return { success: true, data };
    } catch (error) {
        console.error("Error applying rebalancing:", error);
        return {
            success: false,
            message: error.message || "Network error",
        };
    }
};

// ---------- BATCH UPDATE PORTFOLIO
export const batchUpdateHoldings = async (portfolioId, holdings) => {
    try {
        const jwtToken = sessionStorage.getItem("authToken");
        if (!jwtToken) return { success: false, authExpired: true };
        const response = await fetch(
            `${base_url}/api/v1/portfolios/${portfolioId}/holdings/batch`,
            {
                method: "PATCH",
                headers: { ...headers, Authorization: `Bearer ${jwtToken}` },
                credentials: "include", // Include cookies for authentication
                body: JSON.stringify(holdings),
            }
        );

        // Handle authentication errors
        if (response.status === 401 || response.status === 403) {
            return { success: false, authExpired: true };
        }

        const data = await response.json();

        if (!response.ok) {
            return {
                success: false,
                message: data.message || "Failed to batch update holdings",
            };
        }

        return { success: true, data };
    } catch (error) {
        console.error("Error batch updating holdings:", error);
        return {
            success: false,
            message: error.message || "Network error",
        };
    }
};

export const getPortfolioOverallRatings = async (portfolioId) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };
    try {
        const response = await axios.get(
            `${base_url}/api/v1/portfolios/${portfolioId}/overall-ratings`,
            {
                headers: { ...headers, Authorization: `Bearer ${jwtToken}` },
                withCredentials: false,
            }
        );
        return {
            success: response.data?.response_status === "SUCCESS",
            data: response.data,
        };
    } catch (error) {
        if (error?.response?.status === 401) return { success: false, authExpired: true };
        return { success: false, error };
    }
};
// ============================================
// ADD this function to your portfolio_api.js
// ============================================

export const efAddToPortfolio = async (body) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };
    const token = sessionStorage.getItem("authToken");

    try {
        const res = await axios.post(
            `${base_url}/api/v1/portfolios/ef-add-to-portfolio`,
            body,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return { success: res.status === 200 || res.status === 201, data: res.data };
    } catch (e) {
        return { success: false, error: e };
    }
};

export const createPortfolioFromWatchlist1 = async ({
    rebalance,
    portfolio_costbasis,
    tickers,
    body,
}) => {
    const jwtToken = sessionStorage.getItem("authToken");
    if (!jwtToken) return { success: false, authExpired: true };
    const token = sessionStorage.getItem("authToken");

    try {
        const res = await axios.post(
            `${base_url}/api/v1/portfolios`,
            body,
            {
                params: {
                    rebalance,
                    portfolio_costbasis,
                    tickers,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return { success: res.status === 200 || res.status === 201, data: res.data };
    } catch (e) {
        if (e?.response?.status === 500)
            return { success: false, error: { message: "We are unable to create the portfolio. Please try again later." } };

        const detail =
            e?.response?.data?.detail ||
            e?.response?.data?.message ||
            e?.message ||
            "Failed to create portfolio";
        return { success: false, error: { message: detail } };
    }
};


